import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import StockMovementsTable from '../inventory/StockMovementsTable';

const SprayStockMovementsPage: React.FC = () => {
  const { t } = useTranslation();

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('spray.title'), to: '/protection' },
    { label: t('spray.stockMovements.title') },
  ]);

  return (
    <div data-testid="spray-stock-movements-page">
      <PageHeader
        title={t('spray.stockMovements.title')}
        meta={t('spray.stockMovements.meta')}
      />
      <StockMovementsTable scope="chemical" />
    </div>
  );
};

export default SprayStockMovementsPage;
